import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {BonusesStore} from '@/stores/BonusesStore/BonusesStore';

export class BonusesInfoSharedUseCase {
  constructor(private readonly bonusesStore: BonusesStore) {}

  public setBonusesActiveTabBonuses = (): void => {
    this.bonusesStore.setActiveTabBonuses();
  };

  public setBonusesActiveTabUserBonuses = (): void => {
    this.bonusesStore.setActiveTabUserBonuses();
  };
}

injected(BonusesInfoSharedUseCase, DI_TOKENS.bonusesStore);
